// Layout route for /admin/bonds — pure passthrough (Outlet only). The
// list page lives in admin.bonds.index.tsx; the detail page in
// admin.bonds.$id.tsx. Without this layout TanStack would treat the
// list file as the parent of the detail file, and the detail
// component would never get a place to render.

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/bonds')({
  component: BondsLayout,
});

function BondsLayout() {
  return <Outlet />;
}
